import React from "react";
import { Link } from "react-router-dom";
import { getCategoryName, getCategoryColor } from "../data/posts";
import { getPostImage } from "../data/postImages";

function PostCard({ post }) {
  const image = getPostImage(post);

  return (
    <article
      className="post-card post-card--text"
      style={{ borderTopColor: getCategoryColor(post.category) }}
    >
      {image ? (
        <div className="post-card-img-wrap">
          <Link to={`/post/${post.slug}`}>
            <img src={image} alt={post.title} className="post-card-img" />
          </Link>
          <span
            className="post-cat-badge post-cat-badge--overlay"
            style={{ background: getCategoryColor(post.category) }}
          >
            <Link to={`/category/${post.category}`}>{getCategoryName(post.category)}</Link>
          </span>
        </div>
      ) : (
        <span
          className="post-cat-badge"
          style={{ background: getCategoryColor(post.category) }}
        >
          <Link to={`/category/${post.category}`}>{getCategoryName(post.category)}</Link>
        </span>
      )}

      <h3 className="post-title">
        <Link to={`/post/${post.slug}`}>{post.title}</Link>
      </h3>

      <p className="post-excerpt">{post.excerpt}</p>

      <Link to={`/post/${post.slug}`} className="read-more">
        Continue Reading »
      </Link>
    </article>
  );
}

export default PostCard;
